import axios from "axios";

export default class Cookie {
  static acceptCookies ( callback ) {
    axios.post( "/umbraco/Surface/CookiesSurface/AcceptCookies" )
      .then( response => {
        if ( response.data.response ) {
          console.log( "Cookies accepted successfully" );
        } else {
          console.error( "Error accepted cookies", response.data.errorMessage, "cookie" );
        }
      } )
      .catch( error => {
        console.error( "Error accepted cookies", error, "cookie" );
      } );

    if ( callback ) {
      callback();
    }
  }

  static denyCookies ( callback ) {
    axios.post( "/umbraco/Surface/CookiesSurface/DenyCookies" )
      .then( response => {
        if ( response.data.response ) {
          console.log( "Cookies denied successfully" );
        } else {
          console.error( "Error denying cookies", response.data.errorMessage, "cookie" );
        }
      } )
      .catch( error => {
        console.error( "Error denying cookies", error, "cookie" );
      } );

    if ( callback ) {
      callback();
    }
  }

  static createCookie ( name, value, days ) {
    let expires;
    if ( days ) {
      const date = new Date();
      date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
      expires = `; expires=${date.toUTCString()}`;
    } else {
      expires = "";
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
  }

  static getCookie ( cookieName ) {
    if ( document.cookie.length > 0 ) {
      let cookiePrefixIndex = document.cookie.indexOf( `${cookieName}=` );

      if ( cookiePrefixIndex !== -1 ) {
        cookiePrefixIndex = cookiePrefixIndex + cookieName.length + 1;
        let cookieSuffix = document.cookie.indexOf( ";", cookiePrefixIndex );

        if ( cookieSuffix === -1 ) {
          cookieSuffix = document.cookie.length;
        }
        return unescape( document.cookie.substring( cookiePrefixIndex, cookieSuffix ) );
      }
    }
    return "";
  }
}
